import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  output,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {
  CcdlDividerComponent,
  CcdlNavBarComponent,
  CcdlNavList,
  NavList,
} from '@cpm-pr1618001/ng-design-lib';

@Component({
  selector: 'fm-dashboard-ui',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    CcdlNavBarComponent,
    CcdlDividerComponent,
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardComponent {
  @Input()
  navigationList!: NavList[];

  navigationClickEventEmitter = output<CcdlNavList>();

  onNavigationEmitter(linkName: CcdlNavList): void {
    this.navigationClickEventEmitter.emit(linkName);
  }
}
